/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Fine_Print_MinimumInputs */

const en_campaigns_mag7_fine_print_minimum = /** @type {(inputs: Campaigns_Mag7_Fine_Print_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A minimum deposit of $300 is required to be eligible for rewards.`)
};

const de_campaigns_mag7_fine_print_minimum = /** @type {(inputs: Campaigns_Mag7_Fine_Print_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Teilnahme an den Prämien ist eine Mindesteinzahlung von 300 $ erforderlich.`)
};

const pt_br2_campaigns_mag7_fine_print_minimum = /** @type {(inputs: Campaigns_Mag7_Fine_Print_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É necessário um depósito mínimo de US$ 300 para receber recompensas.`)
};

const tr_campaigns_mag7_fine_print_minimum = /** @type {(inputs: Campaigns_Mag7_Fine_Print_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödüllerden yararlanabilmek için en az $300 yatırılması gerekir.`)
};

const zh_cn2_campaigns_mag7_fine_print_minimum = /** @type {(inputs: Campaigns_Mag7_Fine_Print_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需至少存入 300 美元方可获得奖励资格。`)
};

const zh_hk2_campaigns_mag7_fine_print_minimum = /** @type {(inputs: Campaigns_Mag7_Fine_Print_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`須存入最少 $300 方可享有獎賞資格。`)
};

const ko_kr2_campaigns_mag7_fine_print_minimum = /** @type {(inputs: Campaigns_Mag7_Fine_Print_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드 지급 대상이 되려면 최소 $300의 입금이 필요합니다.`)
};

const ru_ru2_campaigns_mag7_fine_print_minimum = /** @type {(inputs: Campaigns_Mag7_Fine_Print_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для участия в программе вознаграждений требуется депозит не менее $300.`)
};

const es_419_campaigns_mag7_fine_print_minimum = /** @type {(inputs: Campaigns_Mag7_Fine_Print_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requiere un depósito mínimo de $300 para ser elegible para las recompensas.`)
};

/**
* | output |
* | --- |
* | "A minimum deposit of $300 is required to be eligible for rewards." |
*
* @param {Campaigns_Mag7_Fine_Print_MinimumInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_fine_print_minimum = /** @type {((inputs?: Campaigns_Mag7_Fine_Print_MinimumInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Fine_Print_MinimumInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_fine_print_minimum(inputs)
	if (locale === "de") return de_campaigns_mag7_fine_print_minimum(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_fine_print_minimum(inputs)
	if (locale === "tr") return tr_campaigns_mag7_fine_print_minimum(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_fine_print_minimum(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_fine_print_minimum(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_fine_print_minimum(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_fine_print_minimum(inputs)
	return es_419_campaigns_mag7_fine_print_minimum(inputs)
});